import { Link } from 'react-router-dom';
import { FiChevronRight } from 'react-icons/fi';
import { getPublicPagePath } from '../../utils/pageGroups';

export const PageRow = ({ to, title, subtitle, meta }) => (
  <Link
    to={to}
    className="flex items-center justify-between gap-4 rounded-md border border-[#e4d9c8] bg-white px-4 py-4 transition hover:border-[#c9b48a] hover:bg-[#faf8f4]"
  >
    <div className="min-w-0">
      <p className="text-sm font-semibold text-[#130705]">{title}</p>
      {subtitle ? (
        <p className="mt-1 truncate text-[12px] text-[#a8a098]">{subtitle}</p>
      ) : null}
      {meta ? <p className="mt-2 text-[12px] font-medium text-[#785E32]">{meta}</p> : null}
    </div>
    <FiChevronRight className="h-4 w-4 shrink-0 text-[#a8a098]" aria-hidden="true" />
  </Link>
);

export const PagesList = ({ pages, emptyMessage = 'No pages found.', renderActions }) => {
  if (pages.length === 0) {
    return <p className="text-sm text-[#6b635c]">{emptyMessage}</p>;
  }

  return (
    <ul className="space-y-2">
      {pages.map((page) => (
        <li key={page.id} className="flex items-stretch gap-2">
          <div className="min-w-0 flex-1">
            <PageRow
              to={`/dashboard/pages/${page.slug}`}
              title={page.name}
              subtitle={page.description || page.slug}
              meta={`Public URL: ${getPublicPagePath(page.slug, page.description)}`}
            />
          </div>
          {renderActions ? (
            <div className="flex items-center">{renderActions(page)}</div>
          ) : null}
        </li>
      ))}
    </ul>
  );
};
